export const MS = {
  "Open document": "Buka dokumen",
  "Upload file": "Muat naik fail",
  "Drop file here to upload": "Jatuhkan fail di sini untuk dimuat naik",
  "Disc": "Cakera",
  "URL": "URL",
  "FILE": "FILE",
  "SIZE": "SAIZ",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bait",
  "Loading... Please wait.": "Muat turun sila tunggu.",
  "Fit Width": "Lebar Fit",
  "Fit Height": "Tinggi Ketepatan",
  "Password protected document": "Dokumen dilindungi kata laluan",
  "Password": "Kata Laluan",
  "Open": "Buka",
  "Password Required": "Kata laluan diperlukan",
  "Incorrect password": "kata laluan salah",
  "Error": "Ralat",
  "Something went wrong": "Ada yang tidak kena",
  "Server is not available": "Pelayan tidak tersedia",
  "of": "daripada",
  "Please wait...": "Sila tunggu..."
};
